import {
  CardImage,
  type CardImageProps,
} from '@curology/ui-components-web/react/Card/CardImage';
import React from 'react';
import Slider from 'react-slick';

import { AnalyticsEvent, trackEvent } from '@/utils/analytics';

import '../css/mediaImageCarouselStyles.css';
import { getSwipeDirection } from '../utils/utils';

type MediaImageCarouselImage = {
  alt: string;
  url: string;
};

type MediaImageCarouselProps = {
  aspectRatio: CardImageProps['aspectRatio'];
  images: MediaImageCarouselImage[];
  productName: string;
};

const MediaImageCarousel = ({
  aspectRatio,
  images,
  productName,
}: MediaImageCarouselProps) => {
  let heightPercentage;

  if (aspectRatio?.includes(':')) {
    const [widthRatio, heightRatio] = aspectRatio.split(':');

    heightPercentage = (Number(heightRatio) / Number(widthRatio)) * 100;
  } else if (aspectRatio === 'square') {
    heightPercentage = 100;
  }

  return (
    <div
      className="media-image-carousel-container"
      style={heightPercentage ? { paddingTop: `${heightPercentage}%` } : {}}
    >
      <div className="media-image-carousel-inner-container">
        <Slider
          accessibility={true}
          arrows={false}
          beforeChange={(current: number, next: number) => {
            trackEvent(AnalyticsEvent.PRODUCT_CARD_CAROUSEL_SWIPED, {
              imageIndex: next,
              productName,
              swipeDirection: getSwipeDirection(
                current,
                next,
                images.length - 1,
              ),
            });
          }}
          dots={true}
          draggable={true}
          infinite={true}
        >
          {images.map((image) => {
            return (
              <CardImage
                alt={image.alt}
                aspectRatio={aspectRatio}
                className="cur-cursor-default"
                key={image.url}
                onClick={(event) => event.stopPropagation()}
                src={image.url}
              />
            );
          })}
        </Slider>
      </div>
    </div>
  );
};

export default MediaImageCarousel;
